import { parseHexColor } from "./parseHexColor";

export const WCAG_AA_TEXT_CONTRAST = 4.5;

const linearChannel = (value: number) => {
  const channel = value / 255;
  return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
};

export const relativeLuminance = (hex: string): number => {
  const { r, g, b } = parseHexColor(hex);
  return 0.2126 * linearChannel(r) + 0.7152 * linearChannel(g) + 0.0722 * linearChannel(b);
};

export const contrastRatio = (foregroundHex: string, backgroundHex: string): number => {
  const l1 = relativeLuminance(foregroundHex);
  const l2 = relativeLuminance(backgroundHex);
  const [lighter, darker] = l1 > l2 ? [l1, l2] : [l2, l1];
  return (lighter + 0.05) / (darker + 0.05);
};

export const meetsTextContrast = (foregroundHex: string, backgroundHex: string): boolean =>
  contrastRatio(foregroundHex, backgroundHex) >= WCAG_AA_TEXT_CONTRAST;
